<template>
  <div class="dt-details">
    <div class="dt-details--header"> {{$t('artist_details')}} </div>
    <div class="dt-details--body" v-if="artist">
      <div class="dt-details--col">
        <div class="dt-details--row">
          <TextField2
            :id="'artist_name'"
            :placeholder="$t('artist_name')"
            :label="$t('artist_name')"
            :value="artist.artist_name"
            @blur="onTextFieldValueChange"
            :lw="lw"
            :cw="cw"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("name") }}</div>
          <div class="dt-details--value">
            <EditableSpan
              :value="artist.artist_name"
              @change="e => onArtistDetailsChange('artist_name', e)"
            />
            
          </div> -->
        </div>
        <div class="dt-details--row">
          <TextField2
            :id="'artist_announcement'"
            :placeholder="$t('submenu_Billing')"
            :label="$t('submenu_Billing')"
            :value="artist.artist_announcement"
            @blur="onTextFieldValueChange"
            :lw="lw"
            :cw="cw"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("submenu_Billing") }}</div>
          <div class="dt-details--value">
            <EditableSpan
              :value="artist.artist_announcement"
              @change="(e) => onArtistDetailsChange('artist_announcement', e)"
            />
          </div> -->
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <TextField2
            :id="'performance_type'"
            :placeholder="$t('performance')"
            :label="$t('performance')"
            :value="artist.performance_type"
            @blur="onTextFieldValueChange"
            :lw="lw"
            :cw="cw"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("performance") }}</div>
          <div class="dt-details--value">
            <div>
              <EditableSpan
                :value="artist.performance_type"
                @change="(e) => onArtistDetailsChange('performance_type', e)"
              />
            </div>
          </div> -->
        </div>
        <div class="dt-details--row">
          <TextField2
            :id="'performance_type'"
            :placeholder="$t('main_contact')"
            :label="$t('main_contact')"
            :value="main_contact.contact_name"
            :disabled="true"
            :noDisabledStyle="true"
            :lw="lw"
            :cw="cw"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("main_contact") }}</div>
          <div class="dt-details--value">
            <div>{{ main_contact.contact_name }}</div>
          </div> -->
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <Dropdown2
            :label="$t('marketing_type')"
            :placeholder="$t('select')+' ' + $t('marketing_type')"
            :options="artist_types"
            :selected="artist_types.find((e) => e.value == artist.artist_type)"
            v-on:selectedChange="
              (e) => onArtistDetailsChange('artist_type', e.value || '')
            "
            :lw="lw"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("marketing_type") }}</div>
          <div class="dt-details--value">
            <Dropdown
              :options="artist_types"
              :selected="
                artist_types.find((e) => e.value == artist.artist_type)
              "
              v-on:selectedChange="
                (e) => onArtistDetailsChange('artist_type', e.value || '')
              "
              deselect
              :config="dropdownConfig"
              :placeholder="''"
            ></Dropdown>
          </div> -->
        </div>
        <div class="dt-details--row">
          <TextField2
            :id="'phone1'"
            :placeholder="$t('phone1')"
            :label="$t('phone1')"
            :value="main_contact.phone1"
            @blur="onMainContactTextFieldChange"
            :lw="lw"
            :cw="cw"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("phone1") }}</div>
          <div class="dt-details--value">
            <EditableSpan
              :value="main_contact.phone1"
              @change="(e) => onMainContactChange('phone1', e)"
            />
          </div> -->
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <TextField2
            :id="'url1'"
            :placeholder="$t('url1')"
            :label="$t('url1')"
            :value="artist.url1"
            @blur="onTextFieldValueChange"
            :lw="lw"
            :cw="cw"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("url1") }}</div>
          <div class="dt-details--value">
            <EditableSpan
              :value="artist.url1"
              @change="(e) => onArtistDetailsChange('url1', e)"
            />
          </div> -->
        </div>
        <div class="dt-details--row">
          <TextField2
            :id="'url2'"
            :placeholder="$t('url2')"
            :label="$t('url2')"
            :value="artist.url2"
            @blur="onTextFieldValueChange"
            :lw="lw"
            :cw="cw"
            bb="none"
            style="width: 100%"
          />
          <!-- <div class="dt-details--label">{{ $t("url2") }}</div>
          <div class="dt-details--value">
            <EditableSpan
              :value="artist.url2"
              @change="(e) => onArtistDetailsChange('url2', e)"
            />
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "../../store/types";
// import EditableSpan from "@/plugins/editable-span/editable-span";
import { createDropdownConfig } from "../../../../plugins/dropdown";

export default {
  components: {
    // EditableSpan,
  },
  props: {
    artist: {
      type: Object,
    },
    main_contact: {
      type: Object,
    },
  },
  data: function () {
    return {
      dropdownConfig: createDropdownConfig({
        iconHoverStyle: 1,
      }),
      lw: "80px",
      cw: "110px",
    };
  },
  computed: {
    artist_types: function () {
      return [
        { text: this.$t("roster_artist"), value: "roster_artist" },
        { text: this.$t("external_artist"), value: "external_artist" },
      ];
    },
  },
  methods: {
    onArtistDetailsChange: function (name, value) {
      this.$emit("updated", {
        name,
        value,
      });
    },
    onMainContactTextFieldChange: function ({ name, value }) {
      if (!this.main_contact) {
        this.$emit("mc_updated", {
          name,
          value,
        });
      }
    },
    onTextFieldValueChange({ name, value }) {
      this.$emit("updated", {
        name,
        value,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.dt-details {
  .dt-details--row {
    padding-left: 0px !important;
  }
  /* .dt-details--body {
    .dt-details--col:nth-child(2) {
      .dt-details--row {
        .dt-details--label {
          flex: 1.5;
        }
      }
    }
  } */
}
</style>
